export default "__VITE_ASSET__PtKo60Dz__"